export interface GetAppListModel {
  appName: string;
  pageIndex: number;
  perPage: number;
}